export var ExamStatus;
(function (ExamStatus) {
    ExamStatus["NOTSTARTED"] = "NOTSTARTED";
    ExamStatus["INPROGRESS"] = "INPROGRESS";
    ExamStatus["COMPLETED"] = "COMPLETED";
})(ExamStatus || (ExamStatus = {}));
